import { useWeb3 } from "logic/components";
import { ERC20V2 } from "logic/pages/LoansPage/data/types";
import { Address } from "viem";

import { useWithdrawBridgeTx } from "../WithdrawModal/useWithdrawBridgeTx";

interface useBridgeTxParams {
  token: ERC20V2;
  chainId: number;
  amount: bigint;
}

export function useBridgeTx(params: useBridgeTxParams) {
  const { token, chainId, amount } = params;
  const { address: connectedAddress } = useWeb3();

  return useWithdrawBridgeTx({
    amount,
    token,
    chainId,
    recipient: connectedAddress as Address,
    mainActionLabel: "Bridge",
  });
}
